import React from 'react';

import { isAcceptedRegion } from '../../../utilities/locale-utilities';
import Link from '../../Generic/Link/Link';
import TRANSLATIONS from './translations@default.json';

const NewEnergyRatingInformation = () => {
	if (isAcceptedRegion(['ADE'])) {
		return null;
	}

	return (
		<div className="text-sm md:text-body-xs text-primary px-4 pt-4 md:pt-0 md:mb-4">
			<div className="bg-gray-10 p-4 rounded">
				<span className="font-bold">{TRANSLATIONS.newEnergyScale}</span>
				{TRANSLATIONS.paragraph1}
				<div className="pt-2 pb-1">{TRANSLATIONS.paragraph2}</div>

				<Link
					dataTag="energy rating message learn more"
					url={TRANSLATIONS.link}
					classes="text-cta-action font-bold"
					text={TRANSLATIONS.learnMore}
					OpenInNewWindow
				/>
			</div>
		</div>
	);
};
export default NewEnergyRatingInformation;
